import { FC, MouseEvent } from 'react';
import classNames from 'classnames';
import { useQlubRouter } from '../../../../../hook/router';
import { interpolateT, useTranslation } from '../../../../../hook/translations';
import { getAvailableLang } from '../../../../../utility/k_lang';

import styles from './index.module.scss';

interface IPrivacyConsentMessageProps {
    modalCloseHandler?: () => void;
    className?: string;
}

const PrivacyConsentMessage: FC<IPrivacyConsentMessageProps> = ({ modalCloseHandler, className }) => {
    const { t } = useTranslation('common');
    const { url, lang, routerPush } = useQlubRouter();

    const handleClick = (redirectTo: string) => (e: MouseEvent<HTMLSpanElement>) => {
        e.preventDefault();

        routerPush(`/qr/[cc]/${redirectTo}`, {
            cc: url.cc,
            ...getAvailableLang(lang),
        });

        if (modalCloseHandler) {
            modalCloseHandler();
        }

        document.getElementById('menuCloseBtn')?.click();
    };

    return (
        <span className={classNames(styles.message, className)}>
            {interpolateT(
                t('I have read and agree to the <privacy> and <terms>, and I consent to receive communications'),
                {
                    terms: <span onClick={handleClick('terms')}>{t('Terms and Conditions')}</span>,
                    privacy: <span onClick={handleClick('privacy')}>{t('Privacy Policy')}</span>,
                },
            )}
        </span>
    );
};

export default PrivacyConsentMessage;
